import { useEffect } from "react";
import { usePatchPortfolioBuildingSavingsMutation } from "web_myplann/Api/Portfolio/Mutations/usePatchPortfolioBuildingSavingsMutation";
import type { PortfolioDetailResponseDTO } from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { getPortfolioTitle } from "web_myplann/Portfolio/Components/PortfolioSections/portfolioListItemHelpers";
import { getBuildingSavingsFormSchema } from "web_myplann/Portfolio/Forms/BuildingSavingsForm/buildingSavingsFormSchema";
import { mapPortfolioToBuildingSavingsForm } from "web_myplann/Portfolio/Forms/BuildingSavingsForm/mapPortfolioToBuildingSavingsForm";
import { useEditPortfolioForm } from "web_myplann/Portfolio/PortfolioShared/useEditPortfolioForm";

type UseEditBuildingSavingsFormArgs = {
	portfolioId: number;
	portfolio: PortfolioDetailResponseDTO;
	detailRoute: string;
};

export const useEditBuildingSavingsForm = ({
	portfolioId,
	portfolio,
	detailRoute,
}: UseEditBuildingSavingsFormArgs) => {
	const { t } = useResource();
	const { mutate, isPending } =
		usePatchPortfolioBuildingSavingsMutation(portfolioId);

	const { form, onSubmit } = useEditPortfolioForm({
		schema: getBuildingSavingsFormSchema(t),
		defaultValues: mapPortfolioToBuildingSavingsForm(portfolio),
		mutate,
		successToast: t(Resources.Portfolio.EditPortfolio.savedToast, {
			type: getPortfolioTitle(portfolio, t),
		}),
		redirectTo: detailRoute,
	});

	useEffect(() => {
		form.trigger();
	}, [form.trigger]);

	return { form, onSubmit, isPending };
};
